import React from "react";
import "./terms.css";
import Banner from "./banner";

const TermsOfService = () => {
  return (
<>
    <Banner
        title="Terms of Service"
        subtitle="Please read our terms and conditions carefully before using our services."
        image="/images/couch.png"
      />
    
    <div className="terms-wrapper">
      <div className="terms-card">

        <h1 className="terms-title">Terms of Service</h1>

        <section className="terms-section">
          <h4 className="terms-heading">Overview</h4>
          <p className="terms-text">
            This website is operated by Paab India. Throughout the site, the terms “we”, “us” and “our” refer to Paab India.
            Paab India offers this website, including all information, tools and services available from this site to you,
            the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.
          </p>
          <p className="terms-text">
            By visiting our site and/or purchasing something from us, you engage in our “Service” and agree to be bound by
            the following terms and conditions.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 1 – Online Store Terms</h4>
          <ul className="terms-list">
            <li className="terms-item">You must be at least the age of majority.</li>
            <li className="terms-item">You may not use products for illegal purposes.</li>
            <li className="terms-item">No transmission of viruses or malicious code.</li>
            <li className="terms-item">Violation may result in termination.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 2 – General Conditions</h4>
          <ul className="terms-list">
            <li className="terms-item">We may refuse service at any time.</li>
            <li className="terms-item">Content may transfer over networks.</li>
            <li className="terms-item">Credit card data is encrypted.</li>
            <li className="terms-item">No unauthorized copying or resale.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 3 – Accuracy of Information</h4>
          <p className="terms-text">
            We are not responsible if information on this site is not accurate, complete or current.
            Any reliance on the material is at your own risk.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 4 – Modifications to Service</h4>
          <ul className="terms-list">
            <li className="terms-item">Prices may change without notice.</li>
            <li className="terms-item">We may modify or discontinue services anytime.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 5 – Products or Services</h4>
          <ul className="terms-list">
            <li className="terms-item">Some products may be online only.</li>
            <li className="terms-item">Product colors may vary by display.</li>
            <li className="terms-item">We may limit or discontinue products.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 6 – Billing and Account Information</h4>
          <ul className="terms-list">
            <li className="terms-item">We may refuse or cancel orders.</li>
            <li className="terms-item">Provide accurate account details.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 7 – Optional Tools</h4>
          <p className="terms-text">
            Third-party tools are provided “as is” without warranties or conditions.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 8 – Third-Party Links</h4>
          <p className="terms-text">
            We are not responsible for third-party websites or materials.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 9 – User Comments</h4>
          <p className="terms-text">
            We may use submitted comments without restriction. Comments must not violate any laws or rights.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 10 – Personal Information</h4>
          <p className="terms-text">
            Personal information is governed by our Privacy Policy.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 11 – Errors and Omissions</h4>
          <p className="terms-text">
            We may correct errors or update information at any time without notice.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 12 – Prohibited Uses</h4>
          <p className="terms-text">
            You may not use the site for unlawful, abusive, harmful, or fraudulent activities.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 13 – Disclaimer of Warranties</h4>
          <p className="terms-text">
            Services are provided “as is” without warranties. We are not liable for damages.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 14 – Indemnification</h4>
          <p className="terms-text">
            You agree to indemnify Paab India against claims arising from your breach of terms.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 15 – Severability</h4>
          <p className="terms-text">
            Invalid provisions do not affect remaining terms.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 16 – Termination</h4>
          <p className="terms-text">
            We may terminate services if terms are violated.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 17 – Entire Agreement</h4>
          <p className="terms-text">
            These terms constitute the entire agreement.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 18 – Governing Law</h4>
          <p className="terms-text">
            Governed by the laws of India.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 19 – Changes to Terms</h4>
          <p className="terms-text">
            We may update terms anytime. Continued use means acceptance.
          </p>
        </section>

        <section className="terms-section">
          <h4 className="terms-heading">Section 20 – Contact Information</h4>
          <p className="terms-text"><strong>Email:</strong> contact@paab.in</p>
          
          <p className="terms-text">
            <strong>Address:</strong> FACTORY / OFFICEPlot A-163, Sector-80,
Noida, G.B. Nagar,
U.P - 201305, INDIA
          </p>
        </section>

      </div>
    </div>
</>
  );
};

export default TermsOfService;